module.exports = __webpack_public_path__ + "assets/pdf/sauvignon-blanc.caac711f.pdf";